module.exports = __webpack_public_path__ + "static/assets/9f7634765fef757191ac479447b24387.svg";